const setWheelGameSetting = (data) => ({
  type: 'WHEEL_GAME_SETTING',
  data: data
})

export { setWheelGameSetting }
